import React, { useRef, useState } from "react";
import { read_cookie } from "sfcookies";
import InventoryTable from "../../../InventoryTable/InventoryTable";
import ProductsDetail from "./ProductsDetail";

export default function ProductProviders () {
    const tableRef = useRef( null );
    const [showProductDetail, setShowProductDetail] = useState( false );
    const [rowData, setRowData] = useState( null );

    const authToken = read_cookie( "inventory-tkn" );

    const handleRowAction = ( action, item ) => {
        if ( action === 'view' ) {
            setRowData( item );
            setShowProductDetail( true );
        }
    };

    const handleError = ( error ) => {
        console.error( 'Error en InventoryTable (Providers):', error );
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <InventoryTable
                        ref={tableRef}
                        authToken={authToken}
                        baseUrl={process.env.REACT_APP_BASE_URL}
                        onRowAction={handleRowAction}
                        onError={handleError}
                    />
                </div>
            </div>

            {showProductDetail ? (
                <ProductsDetail
                    show={showProductDetail}
                    product_id={rowData?.id}
                    handleClose={() => setShowProductDetail( false )}
                />
            ) : null}
        </div>
    );
}